import api from "../Api";
import routes from "../constants/ApiRoutesConstants";

import { saveToken } from "utils/TokenUtils";

export default async function SignInService(formData) {
  const jsonData = Object.fromEntries(formData.entries());

  const res = await api.post(routes.LOGIN, jsonData);

  if (res.data.access_token) {
    const token = res.data.access_token;
    saveToken(token);
  }

  return res;
}
